import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { STORE_BASE_PATH } from '../../common/constants';
import { supportedCurrencies } from '../../common/supportedCurrencies';
import { getIntlFormatDate, getIntlFormaTime } from '../../common/utils';
import { defaultVehicleProfile } from '../vehicleProfile/defaultVehicleProfile';

interface RouteDeparture {
    departureTime: string;
    departureDate: string;
}

export interface RouteConstraints {
    isAvoidAccessHighway: boolean;
    isAvoidTollRoads: boolean;
    isAvoidFerry: boolean;
    isAvoidTunnel: boolean;
}

export interface RouteCosts {
    value: number;
    currency: string;
}

export interface RouteState {
    departure: RouteDeparture;
    constraints: RouteConstraints;
    vehicleCosts: RouteCosts;
    energyCosts: RouteCosts;
}

const initialState: RouteState = {
    departure: {
        departureTime: getIntlFormaTime('en-US', new Date()),
        departureDate: getIntlFormatDate('en-US', new Date()),
    },
    constraints: {
        isAvoidAccessHighway: false,
        isAvoidTollRoads: false,
        isAvoidFerry: false,
        isAvoidTunnel: false,
    },
    vehicleCosts: {
        value: defaultVehicleProfile.costPerKm,
        currency: supportedCurrencies[0],
    },
    energyCosts: {
        value: defaultVehicleProfile.costPerKWh,
        currency: supportedCurrencies[0],
    },
};

export const routeSlice = createSlice({
    name: `${STORE_BASE_PATH}route`,
    initialState,
    reducers: {
        updateRouteDeparture: (state: RouteState, action: PayloadAction<RouteDeparture>) => {
            state.departure = action.payload;
        },
        updateRouteConstraints: (state: RouteState, action: PayloadAction<RouteConstraints>) => {
            state.constraints = action.payload;
        },
        updateVehicleCosts: (state: RouteState, action: PayloadAction<RouteCosts>) => {
            state.vehicleCosts = action.payload;
        },
        updateEnergyCosts: (state: RouteState, action: PayloadAction<RouteCosts>) => {
            state.energyCosts = action.payload;
        },
    },
});

export const { updateRouteDeparture, updateRouteConstraints, updateVehicleCosts, updateEnergyCosts } =
    routeSlice.actions;

export default routeSlice.reducer;
